import React from "react";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "../data/blogPosts";

export default function BlogPostRelated({ currentSlug }) {
  const currentPost = BLOG_POSTS.find((post) => post.slug === currentSlug);
  const relatedPosts = BLOG_POSTS.filter(
    (post) => post.slug !== currentSlug
  ).slice(0, 4);
  const tags = currentPost
    ? Array.from(new Set([currentPost.tag, "Solo Travel", "Adventure", "Culture"])).slice(0, 4)
    : ["Solo Travel", "Adventure", "Culture", "Travel Guide"];

  return (
    <section className="max-w-6xl mx-auto px-6 pb-4">
      <div className="flex items-center gap-3 flex-wrap mb-10">
        <span className="text-sm font-semibold text-slate-900">Tags:</span>
        {tags.map((tag) => (
          <span
            key={tag}
            className="text-xs font-semibold text-[#7209B7] bg-purple-50 px-3 py-1.5 rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>

      <h2 className="text-xl font-extrabold text-slate-900 mb-5">
        You Might Also Like
      </h2>
      <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-5 overflow-x-auto sm:overflow-visible -mx-6 px-6 sm:mx-0 sm:px-0 pb-2 snap-x snap-mandatory">
        {relatedPosts.map((post) => (
          <a
            href={`/blog/${post.slug}`}
            key={post.slug}
            className="bg-white border border-slate-100 shadow-sm rounded-2xl overflow-hidden shrink-0 w-[46%] sm:w-auto sm:shrink snap-start"
          >
            <div className="h-32 bg-slate-200">
              <img
                src={post.thumbnail}
                alt={post.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h4 className="font-semibold text-slate-900 text-sm leading-snug mb-2 line-clamp-2">
                {post.title}
              </h4>
              <div className="flex items-center justify-between">
                <p className="text-xs text-slate-400">
                  {post.date}
                  <br />
                  {post.readTime}
                </p>
                <span
                  aria-label="Read post"
                  className="w-8 h-8 rounded-full bg-purple-50 text-[#7209B7] flex items-center justify-center shrink-0 hover:bg-purple-100 transition-colors"
                >
                  <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
